import { Select, SelectContent, SelectItem, SelectTrigger } from "./Select";
import { BaseClassicChoice, ClassicSelectProps } from "./interfaces";
import DoneIcon from "@material-design-icons/svg/outlined/done.svg";
import cn from "classnames";

const ClassicSelect = <TValue extends BaseClassicChoice>({
    title,
    badge,
    choices,
    textValue,
    icon: Icon,
    label,
    renderChoice,
    className,
    buttonClassName,
    direction,
    emptyText = "None selected",
    ...selectProps
}: ClassicSelectProps<TValue>) => {
    const byKey = selectProps.by ?? "name";

    textValue = textValue
        ? textValue
        : Array.isArray(selectProps.value)
          ? selectProps.value.map((v) => String(v[byKey])).join(", ")
          : selectProps.value
            ? String(selectProps.value[byKey as keyof TValue])
            : "";

    renderChoice = renderChoice
        ? renderChoice
        : (choice) => <>{String(choice[byKey])}</>;

    return (
        <div className={cn("flex w-full flex-col", className)}>
            {typeof label === "string" ? (
                <span className="text-sm text-gray-500">{label}</span>
            ) : (
                label
            )}
            <Select {...selectProps}>
                <SelectTrigger
                    title={title}
                    badge={badge}
                    className={cn(Icon && "justify-between", buttonClassName)}
                    disabled={selectProps.disabled}
                >
                    <span
                        className={cn(
                            "truncate",
                            !textValue && "text-gray-500",
                        )}
                    >
                        {textValue || emptyText}
                    </span>
                    {Icon && (
                        <Icon
                            width="18"
                            height="18"
                            className="flex-shrink-0"
                        />
                    )}
                </SelectTrigger>
                <SelectContent
                    className={cn(direction === "up" && "bottom-full mb-1")}
                >
                    {choices.map((choice) => (
                        <SelectItem key={choice.id} value={choice}>
                            {({ selected }: { selected: boolean }) => (
                                <>
                                    <span>{renderChoice(choice)}</span>
                                    {selected && (
                                        <DoneIcon
                                            className="fill-sky-500"
                                            width="16"
                                            height="16"
                                        />
                                    )}
                                </>
                            )}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
};

export default ClassicSelect;
